<template>
	<v-expansion-panel>
		<v-expansion-panel-header expand-icon="" color="secondary">
			<v-toolbar rounded color="secondary" elevation="0" :outlined="false" dense class="pt-0 pb-0 mr-0 ml-0 font-weight-bold white--text justify-center text-center"
				><v-spacer></v-spacer><v-toolbar-title class="justify-center text-center" style="font-size: 32px">{{ title }}</v-toolbar-title
				><v-spacer></v-spacer
			></v-toolbar>
		</v-expansion-panel-header>
		<v-expansion-panel-content class="mx-auto justify-center text-center ml-5 mr-5 mt-5">
			<v-card-text class="justify-center text-center">
				<v-row class="justify-left text-center">
					<v-col cols="2">
						<v-select
							outlined
							:append-icon="readonly['Approved'] ? 'mode_edit' : 'done'"
							:items="[false, true]"
							:readonly="readonly['Approved']"
							label="Approved"
							:v-model="company.approved"
							:value="company.approved"
							@click:append="readonly['Approved'] ? edit('Approved') : finished('Approved')"
						></v-select>
					</v-col>
					<v-col cols="2">
						<v-select
							outlined
							:append-icon="readonly['Active'] ? 'mode_edit' : 'done'"
							:items="[false, true]"
							:readonly="readonly['Active']"
							label="Active"
							:v-model="company.isActive"
							:value="company.isActive"
							@click:append="readonly['Active'] ? edit('Active') : finished('Active')"
						></v-select>
					</v-col>
					<v-col cols="2">
						<v-select
							outlined
							:append-icon="readonly['terms_conditions'] ? 'mode_edit' : 'done'"
							:items="[false, true]"
							:readonly="readonly['terms_conditions']"
							label="T&Cs"
							:v-model="company.terms_conditions"
							:value="company.terms_conditions"
							@click:append="readonly['terms_conditions'] ? edit('terms_conditions') : finished('terms_conditions')"
						></v-select>
					</v-col>
					<v-col cols="5">
						<v-text-field outlined readonly :value="company.id" label="GUID"></v-text-field>
					</v-col>
					<v-col cols="4">
						<v-text-field outlined readonly :value="company.createdAt" label="created"></v-text-field>
					</v-col>
					<v-col cols="2">
						<v-text-field outlined readonly :value="company.isDeleted" label="Soft Deleted"></v-text-field>
					</v-col>
					<v-col cols="4">
						<v-text-field outlined readonly :value="company.updatedAt ? company.updatedAt : 'never updated'" label="last updated"></v-text-field>
					</v-col>
					<v-col cols="5">
						<v-text-field outlined readonly :value="company.updatedBy" label="last updated by"></v-text-field>
					</v-col>
				</v-row>
			</v-card-text>
		</v-expansion-panel-content>
	</v-expansion-panel>
</template>

<script>
export default {
	name: 'AdminViewPracticeAccountManagementCard',
	components: {},
	props: {
		company: { type: Object, optional: false, required: true },
	},
	data: () => ({
		title: 'Account Management',
		readonly: {
			Active: true,
			Approved: true,
			terms_conditions: true,
		},
	}),
	methods: {
		edit(key) {
			Object.keys(this.readonly)
				.filter(k => k != key && !this.readonly[k])
				.forEach(k => this.finished(k));
			this.readonly[key] = false;
			this.$forceUpdate();
		},
		finished(key) {
			this.readonly[key] = true;
			this.$forceUpdate();
		},
	},
};
</script>
